import { defineStore } from 'pinia'
import api from '@/api/index.js'
export const useUserStore = defineStore('user', {
  state: () => ({
    userId: '',
    username: '',
    displayName: '',
    accessToken: null,
    refreshToken: null,
    isAdmin: false,
  }),
  actions: {
    async fetchToken() {
      let result = await api.refreshToken(this.refreshToken)

      if (result?.access_token && result?.refresh_token) {
        this.setToken(result.access_token, result.refresh_token)
      }
    },

    async logout() {
      this.accessToken = null
      this.refreshToken = null
      this.userId = null
      this.username = null
      this.displayName = null
      this.isAdmin = false

      window.location.replace('/auth/logout')
    },

    setToken(accessToken, refreshToken) {
      this.accessToken = accessToken
      this.refreshToken = refreshToken
    },

    setPassCode(passCode) {
      this.tempPassCode = passCode
    },

    async getUserDetails() {
      let userDetails = await api.getUserDetails()

      if (userDetails) {
        this.userId = userDetails.id
        this.username = userDetails.userPrincipalName
        this.displayName = userDetails.displayName
        this.isAdmin = userDetails.isAdmin
        return true
      }
      return false
    },

    async checkLogin() {
      if (!this.accessToken) {
        return false
      }

      try {
        await this.getUserDetails()
        if (!this.userId) {
          return false
        }
      } catch (error) {
        console.error(error)
        return false
      }
      return true
    },

    async checkCookieTokenIsValid() {
      try {
        if (await this.getUserDetails()) {
          this.accessToken = 'cookie-token'
          this.refreshToken = 'cookie-token'
          if (this.userId) {
            return true
          }
        }
      } catch (error) {
        console.error(error)
      }
      return false
    },
  },
  persist: true,
})
